import { Box, Tooltip, styled } from "@mui/material";
import MxDetailSmallCard from "@rf-l1/page/details/MxDetailCardSmall";
import MxTypography from "@rf-l1/MxTypography";
import { usePropertyDetailPage } from "../../context/PropertyDetailPageContext";
import AltesestateIcon from "@icons-rf/alterestate-icon.svg?react";
import WarnIcon from "@icons-rf/property-panel/warning-red.svg?react";
import dayjs from "dayjs";

/**
 * PropertyAlterestateCard
 *
 * Tarjeta que muestra información sobre la sincronización con Alterestate.
 * - Estado de publicación en Alterestate
 * - Estado de publicación en la red interna de Alterestate
 * - Comisión de venta en Alterestate (si está sincronizado)
 * - Alerta de error de sincronización (si existe)
 *
 * Visible solo para propiedades individuales (no proyectos)
 */
const PropertyAlterestateCard = () => {
  const { alterestate, isProject } = usePropertyDetailPage();

  // No mostrar para proyectos
  if (isProject) {
    return null;
  }

  if (!alterestate) {
    return null;
  }

  return (
    <ContentIcon>
      <Icon />
      <MxDetailSmallCard title="Alterestate">
        <Box display="flex" flexDirection="column" gap={0.5}>
          {alterestate.isFailed && (
            <Box display="flex" justifyContent="flex-end" mb={1}>
              <WarnAlert date={alterestate.isFailed} />
            </Box>
          )}

          <InfoRow
            label="¿Esta publicado en Alterestate?"
            value={alterestate.isSync ? "Si" : "No"}
          />
          <InfoRow
            label="¿Esta publicado en la red interna Alterestate?"
            value={alterestate.isPublished ? "Si" : "No"}
          />
          {alterestate.isSync && (
            <InfoRow
              label="Comisión de venta en Alterestate"
              value={`${alterestate.commission}%`}
              valueColor="primary.main"
            />
          )}
        </Box>
      </MxDetailSmallCard>
    </ContentIcon>
  );
};

const InfoRow = ({
  label,
  value,
  valueColor = "text.secondary"
}: {
  label: string;
  value: string;
  valueColor?: string;
}) => (
  <Box display="grid" gridTemplateColumns="auto 1fr" columnGap={1.25} py={0.25}>
    <MxTypography variant="caption" color="primary.main" fontWeight={700}>
      {label}
    </MxTypography>
    <MxTypography variant="caption" color={valueColor} fontWeight={700}>
      {value}
    </MxTypography>
  </Box>
);

const WarnAlert = ({ date }: { date: string }) => {
  return (
    <Tooltip
      title={`La sincronización ha fallado el ${dayjs(date).format(
        "DD/MM/YYYY"
      )} , si el error persiste favor contactar al equipo de soporte`}
    >
      <Box>
        <IconCustom />
      </Box>
    </Tooltip>
  );
};

const Icon = styled(AltesestateIcon)({
  position: "absolute",
  right: 20,
  top: 20,
  height: 30,
  width: 50,
  zIndex: 1
});

const ContentIcon = styled(Box)({
  position: "relative",
  width: "100%"
});

const IconCustom = styled(WarnIcon)({
  marginTop: 5,
  width: 25,
  height: 25,
  fill: "#d32f2f",
  color: "#d32f2f"
});

export default PropertyAlterestateCard;
